<template>
  <div class="sort-wrapper">
    <i
      :class="[
        'icon_com',
        'comicon_seqfront',
        'icon_asc',
        { 'icon-select': value === 'ascending' }
      ]"
    ></i>
    <i
      :class="[
        'icon_com',
        'comicon_seqend',
        'icon_desc',
        { 'icon-select': value === 'descending' }
      ]"
    ></i>
  </div>
</template>

<script>
/**
 * sort-icon，用于表格表头排序图标
 */
export default {
  props: {
    value: {}
  }
};
</script>

<style lang="less" scoped>
.sort-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  i {
    .text("tiny", "normal");
    transform: scale(10/12);
  }
  .icon_asc {
    position: relative;
    bottom: -3px;
  }
  .icon_desc {
    position: relative;
    top: -3px;
  }
  .icon-select {
    color: @color-highlight;
  }
}
</style>
